import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { GiftCard } from 'src/app/models';

/**
 * Shown when a gift card identification number matches more than one
 * authorized card (POS-1662). Operator/diner must pick exactly one before
 * the payment/redemption flow can continue. No row is pre-selected and the
 * confirm action stays disabled until a row is tapped.
 */
@Component({
  selector: 'pos-gift-card-selection',
  templateUrl: './gift-card-selection.component.html',
  styleUrls: ['./gift-card-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftCardSelectionComponent {
  @Input() giftCards: GiftCard[] = [];
  @Output() readonly cardTapped = new EventEmitter<GiftCard>();

  selectedCard: GiftCard = null;

  onSelectCard(card: GiftCard) {
    this.selectedCard = card;
    this.cardTapped.emit(card);
  }
}
